<template>
    <div>
        <div class="pa-3">
            <v-card class="pt-2 px-3">
                <v-layout class="mx-3 mt-3" row>
                    <div
                        style=""
                        v-if="broadcastsToDisplay.length"
                        class="pt-3 text-xs-center font-weight-medium title"
                    >
                        Broadcasts ({{ broadcastsToDisplay.length }})
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn
                        v-if="broadcastsToDisplay.length"
                        class="mx-1"
                        @click="loadBroadcasts"
                        small
                        color="success"
                        >Refresh</v-btn
                    >
                    <!-- <v-btn
                        v-if="broadcastsToDisplay.length"
                        @click="newBroadcastText()"
                        small
                        color="success"
                        >New Broadcast - Text</v-btn
                    > -->
                    <v-btn
                        v-if="broadcastsToDisplay.length"
                        @click="openSelectNotificationDialog"
                        small
                        color="success"
                        >New Broadcast</v-btn
                    >
                </v-layout>

                <div style="height: 800px; overflow-y: auto;" class="mx-3 mb-3">
                    <div
                        class="headline mt-4 text-xs-center"
                        v-if="!broadcastsToDisplay.length"
                    >
                        No Broadcasts
                    </div>
                    <v-layout justify-center v-if="!broadcastsToDisplay.length">
                        <!-- <v-btn
                            class="mt-3 text-xs-center"
                            @click="newBroadcastText()"
                            small
                            color="success"
                            >New Broadcast - Text</v-btn
                        > -->
                        <v-btn
                            class="mt-3 text-xs-center"
                            @click="openSelectNotificationDialog"
                            small
                            color="success"
                            >New Broadcast</v-btn
                        >
                    </v-layout>
                    <div
                        v-for="(broadcast, index) in broadcastsToDisplay"
                        class="pa-2 mb-2"
                        style="cursor: pointer; border: 1px solid #4caf50; border-radius: 4px"
                    >
                        <v-layout
                            row
                            class="pa-0"
                            justify-space-between
                            @click="expandBroadcast(broadcast)"
                        >
                            <div class="pl-3 font-weight-regular width-300">
                                <span class="font-weight-medium">Name:</span
                                ><br />
                                {{ broadcast.broadcastName }}
                            </div>
                            <div class="pl-3 font-weight-regular width-200">
                                <span class="font-weight-medium">User:</span
                                ><br />
                                {{ broadcast.userName }}
                            </div>
                            <div
                                :title="broadcast.building"
                                class="pl-3 font-weight-regular width-150"
                            >
                                <span class="font-weight-medium">Building:</span
                                ><br />
                                {{ truncateText(broadcast.building) }}
                            </div>
                            <div
                                :title="broadcast.grade"
                                class="pl-3 font-weight-regular width-150"
                            >
                                <span class="font-weight-medium">Grade:</span
                                ><br />
                                {{ truncateText(broadcast.grade) }}
                            </div>
                            <div class="pl-3 font-weight-regular width-150">
                                <span class="font-weight-medium">Type:</span
                                ><br />
                                {{ broadcast.type }}
                            </div>
                            <div v-if="!showBroadcastStatus(broadcast)"></div>
                            <div v-if="showBroadcastStatus(broadcast)">
                                <v-btn
                                    small
                                    color="default"
                                    dark
                                    @click="
                                        openCancelBroadcastDialog(broadcast)
                                    "
                                    >Cancel</v-btn
                                >
                            </div>
                            <div v-if="showBroadcastStatus(broadcast)">
                                <div class="ml-2 mt-3 caption white--text">
                                    <span
                                        style="background-color: #fdb400"
                                        class="pa-1 mt-4"
                                        >{{ broadcast.broadcastStatus }}</span
                                    >
                                </div>
                            </div>
                            <div class="font-weight-regular width-250">
                                <span class="font-weight-medium">Time:</span
                                ><br />{{ getBroadcastTime(broadcast) | time }}
                            </div>
                            <div class="pl-3 font-weight-regular width-250">
                                <span class="font-weight-medium">Total:</span
                                ><br />
                                {{ broadcast.totalCount }}
                            </div>
                            <v-spacer></v-spacer>
                            <v-layout row class="pa-0" justify-end>
                                <div
                                    class="caption pa-1 white--text broadcast-notification-type"
                                    v-if="broadcast.notificationType"
                                >
                                    {{ broadcast.notificationType }}
                                </div>
                            </v-layout>
                            <!-- <audio controls :src="broadcast.audioFile"></audio> -->
                        </v-layout>
                        <div v-if="broadcast.extended">
                            <data-grid
                                v-if="broadcast.type == 'CALL'"
                                class="menahal-calls-grid mt-0"
                                name="immunization-broadcast-call-logs"
                                :url="callsUrl"
                                :columns="callColumns"
                                :hideHeader="true"
                                title="Call Log"
                                :sortOptions="{
                                    enabled: true,
                                    field: 'date',
                                    type: 'desc',
                                }"
                                ref="callGrid"
                            ></data-grid>
                            <data-grid
                                v-if="broadcast.type == 'MESSAGE'"
                                class="menahal-calls-grid mt-0"
                                name="immunization-broadcast-message-logs"
                                :url="messageUrl"
                                :columns="messageColumns"
                                :hideHeader="true"
                                title="Message Log"
                                :sortOptions="{
                                    enabled: true,
                                    field: 'dateTime',
                                    type: 'desc',
                                }"
                                ref="messageGrid"
                            ></data-grid>

                            <data-grid
                                v-if="broadcast.type == 'EMAIL'"
                                class="menahal-calls-grid mt-0"
                                name="immunization-broadcast-email-logs"
                                :url="emailUrl"
                                :columns="emailColumns"
                                :hideHeader="true"
                                title="Email Log"
                                :sortOptions="{
                                    enabled: true,
                                    field: 'date',
                                    type: 'desc',
                                }"
                                ref="emailGrid"
                            ></data-grid>
                        </div>
                    </div>
                    <v-layout justify-center v-if="broadcastsToDisplay.length">
                        <v-pagination
                            v-model="pagination.page"
                            :length="pages"
                            :total-visible="7"
                            v-on:input="setPagianation"
                        ></v-pagination>
                    </v-layout>
                </div>
            </v-card>
        </div>
        <v-dialog v-model="cancelBroadcastDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0">
                    Are you sure?
                </v-card-title>
                <div class="mb-3">
                    This will cancel
                    <span class="font-weight-medium">{{
                        broadcastToCancel.broadcastName
                    }}</span>
                </div>
                <v-card-actions class="mr-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="cancelBroadcastDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        :loading="processing"
                        @click="confirmBroadcastCancellation()"
                        >Confirm</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="selectNotificationDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pt-0 pb-2 pl-0">
                    Select Notification Type
                </v-card-title>
                <v-select
                    :items="notificationTypes"
                    v-model="selectedNotification"
                    label="Notification Type"
                ></v-select>
                <v-card-actions class="mr-0 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="selectNotificationDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        :loading="processing"
                        @click="newBroadcast()"
                        >Confirm</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import moment from "moment";
import { truncate } from "../../utils/helpers.js";

export default {
    data() {
        return {
            broadcasts: [],
            broadcastsToDisplay: [],
            loading: false,

            broadcastToCancel: "",
            cancelBroadcastDialog: false,
            processing: false,

            selectNotificationDialog: false,
            selectedNotification: "",
            notificationTypes: ["IMMUNIZATION", "MEAT"],

            callsUrl: "",
            messageUrl: "",
            emailUrl: "",

            pagination: {
                totalCount: 0,
                rowsPerPage: 9,
                page: 1,
            },

            callColumns: [
                {
                    field: "status",
                    isIcon: true,
                    icon: (value) => {
                        if (!value) return "mdi-clock";

                        switch (value.trim()) {
                            case "COMPLETED":
                                return "mdi-check-circle";
                            case "BUSY":
                                return "mdi-phone-missed";
                            case "OUT OF SERVICE":
                                return "mdi-phone-remove";
                            case "UNKNOWN":
                                return "mdi-phone";
                            case "ERROR":
                                return "mdi-alert-circle";
                            default:
                                return "";
                        }
                    },
                    iconColor: (value) => {
                        if (!value) return "#fdb400";

                        switch (value.trim()) {
                            case "COMPLETED":
                                return "success";
                            case "ERROR":
                                return "#f35123";
                            case "OUT OF SERVICE":
                                return "#f35123";
                            case "UNKNOWN":
                                return "#aeb8bf";
                            case "BUSY":
                                return "#aeb8bf";
                            default:
                                return "#aeb8bf";
                        }
                    },
                },
                {
                    sortable: false,
                    label: "Account ID",
                    field: "accountID",
                    link: (row) => {
                        return row.accountsSource == "DINNER"
                            ? "DinnerAccountView"
                            : "Account View";
                    },
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: true,
                    label: "Name",
                    field: "name",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: false,
                    label: "Hebrew Name",
                    field: "nameH",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: true,
                    label: "Date",
                    field: "date",
                    type: "date",
                    dateOutputFormat: "MM/DD/YYYY h:mm:ss A",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: false,
                    label: "From",
                    field: "from",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: false,
                    label: "To",
                    field: "to",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: false,
                    label: "Direction",
                    field: "direction",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: false,
                    label: "Status",
                    field: "status",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                        filterDropdownItems: [
                            "ERROR",
                            "COMPLETED",
                            "OUT OF SERVICE",
                            "BUSY",
                            "UNKNOWN",
                        ],
                    },
                },
                {
                    sortable: false,
                    label: "Listned",
                    field: "listenedToMessage",
                    hidden: false,
                    type: "boolean",
                    formatFn: (value) => (value ? "Yes" : "No"),
                    filterOptions: {
                        enabled: true,
                        filterDropdownItems: [
                            { value: true, text: "Yes" },
                            { value: false, text: "No" },
                        ],
                    },
                },
            ],

            messageColumns: [
                {
                    field: "status",
                    isIcon: true,
                    icon: (value, row) => {
                        if (!value) return "";

                        switch (value.trim()) {
                            case "ERROR":
                            case "FAILED":
                                return "mdi-message-alert";
                            case "NEW":
                                return "mdi-message-plus";
                            case "QUEUED":
                            case "WAITING":
                            case "PENDING":
                                return "mdi-message-processing";
                            case "SENT":
                                return "mdi-comment-arrow-right";
                            case "UNKNOWN":
                                return "mdi-message-question";
                            case "DELIVERED":
                                return "mdi-message-text";
                            case "UNDELIVERED":
                                return "mdi-close-circle";
                            default:
                                return "";
                        }
                    },
                    iconColor: (value, row) => {
                        if (!value) return "";

                        switch (value.trim()) {
                            case "ERROR":
                            case "FAILED":
                            case "UNDELIVERED":
                                return "#f35123";
                            case "NEW":
                                return "info";
                            case "QUEUED":
                            case "WAITING":
                            case "PENDING":
                                return "#fdb400";
                            case "DELIVERED":
                                return "success";
                            case "SENT":
                            case "UNKNOWN":
                                return "#aeb8bf";
                            default:
                                return "#aeb8bf";
                        }
                    },
                },
                {
                    sortable: false,
                    label: "Account ID",
                    field: "accountID",
                    link: (row) => {
                        return row.accountsSource == "DINNER"
                            ? "DinnerAccountView"
                            : "Account View";
                    },
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: true,
                    label: "Name",
                    field: "name",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: false,
                    label: "Hebrew Name",
                    field: "nameH",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: true,
                    label: "Date",
                    field: "dateTime",
                    type: "date",
                    dateOutputFormat: "MM/DD/YYYY h:mm:ss A",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: false,
                    label: "From",
                    field: "from",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: false,
                    label: "To",
                    field: "to",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: false,
                    label: "Text",
                    field: "text",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: false,
                    label: "Status",
                    field: "status",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                        filterDropdownItems: [
                            "ERROR",
                            "FAILED",
                            "NEW",
                            "QUEUED",
                            "WAITING",
                            "PENDING",
                            "SENT",
                            "UNKNOWN",
                            "DELIVERED",
                            "UNDELIVERED",
                        ],
                    },
                },
            ],

            emailColumns: [
                {
                    field: "status",
                    isIcon: true,
                    icon: (value, row) => {
                        if (!value) return "";

                        switch (value.trim()) {
                            case "PENDING":
                                return "mdi-message-processing";
                            case "SENT":
                                return "mdi-comment-arrow-right";
                            case "UNKNOWN":
                                return "mdi-message-question";
                            case "SENT":
                                return "mdi-message-text";
                            case "FAILED":
                                return "mdi-close-circle";
                            default:
                                return "";
                        }
                    },
                    iconColor: (value, row) => {
                        if (!value) return "";

                        switch (value.trim()) {
                            case "ERROR":
                            case "FAILED":
                            case "UNDELIVERED":
                                return "#f35123";
                            case "QUEUED":
                            case "PENDING":
                                return "#fdb400";
                            case "SENT":
                                return "success";
                            case "UNKNOWN":
                                return "#aeb8bf";
                            default:
                                return "#aeb8bf";
                        }
                    },
                },
                {
                    sortable: false,
                    label: "Account ID",
                    field: "accountId",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: true,
                    label: "Name",
                    field: "name",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: false,
                    label: "Hebrew Name",
                    field: "nameH",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: true,
                    label: "Date",
                    field: "date",
                    type: "date",
                    dateOutputFormat: "MM/DD/YYYY h:mm:ss A",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: false,
                    label: "From",
                    field: "from",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: false,
                    label: "To",
                    field: "to",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: false,
                    label: "Text",
                    field: "text",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: false,
                    label: "Status",
                    field: "status",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                        filterDropdownItems: [
                            "FAILED",
                            "PENDING",
                            "SENT",
                            "UNKNOWN",
                        ],
                    },
                },
            ],
        };
    },
    async mounted() {
        this.loadBroadcasts();
    },
    watch: {},
    beforeDestroy() {},
    computed: {
        pages() {
            return this.pagination.rowsPerPage
                ? Math.ceil(
                      this.broadcasts.length / this.pagination.rowsPerPage,
                  )
                : 0;
        },
    },
    methods: {
        async loadBroadcasts() {
            this.loading = true;

            let url =
                "/odata/broadcastReport?status=&$filter=(isNotification eq true)";

            if (this.getBranch()) {
                url += ` and (userName eq '${
                    this.$store.state.authentication.user
                }')`;
            }

            url += `&$orderby=date desc`;

            const response = await this.$http.get(url);

            this.broadcasts = response.value.map((broadcast) => {
                broadcast.extended = false;

                return broadcast;
            });

            this.broadcastsToDisplay = this.broadcasts.slice(0, 9);

            this.loading = false;
            this.pagination.page = 1;
        },
        getBroadcastTime(broadcast) {
            return broadcast.broadcastTime
                ? broadcast.broadcastTime
                : broadcast.date;
        },
        showBroadcastStatus(broadcast) {
            return broadcast.broadcastStatus != "COMPLETED";
        },
        async confirmBroadcastCancellation() {
            try {
                this.processing = true;

                await this.$http.post("api/broadcast/deleteBroadcast", [
                    this.broadcastToCancel.id,
                ]);

                this.processing = false;
                this.cancelBroadcastDialog = false;
                this.loadBroadcasts();
            } catch (e) {
                this.processing = false;
            }
        },
        openCancelBroadcastDialog(broadcast) {
            this.broadcastToCancel = broadcast;
            this.cancelBroadcastDialog = broadcast;
        },
        expandBroadcast(broadcast) {
            this.broadcasts.forEach((b) => (b.extended = false));

            broadcast.extended = true;

            if (broadcast.type == "MESSAGE") {
                this.messageUrl =
                    "broadcastMessages?broadcastID=" + broadcast.id;
            } else if (broadcast.type == "CALL") {
                this.callsUrl =
                    "broadcastCalls?broadcastID=" +
                    broadcast.id +
                    "&type=&callName=";
            } else {
                this.emailUrl = "broadcastEmails?broadcastID=" + broadcast.id;
            }
        },
        getBranch() {
            return this.$store.state.authentication.branch &&
                !this.$store.state.authentication.branch.includes("null")
                ? this.$store.state.authentication.branch
                : "";
        },
        setPagianation() {
            if (this.getSkip() >= this.pagination.totalCount) return;

            const number =
                (this.pagination.page - 1) * this.pagination.rowsPerPage;

            this.broadcastsToDisplay = this.broadcasts.slice(
                number,
                number + this.pagination.rowsPerPage,
            );
        },
        getSkip() {
            const page = this.pagination.page - 1;

            let skip = page * this.pagination.rowsPerPage;

            if (skip >= this.pagination.totalCount) {
                skip = this.pagination.totalCount - this.pagination.rowsPerPage;
            }

            return skip;
        },
        openSelectNotificationDialog() {
            this.selectNotificationDialog = true;
        },
        newBroadcast() {
            if (this.selectedNotification == "IMMUNIZATION") {
                this.$router.push({
                    name: "NewImmunizationBroadcast",
                });
            } else {
                this.$router.push({
                    name: "NewMeatBroadcast",
                });
            }
        },
        goToAudioLibrary() {
            this.$router.push({
                name: "MenahalAudioLibrary",
            });
        },
        newBroadcastText() {
            this.$router.push({
                name: "MenahalNewBroadcast",
                query: {
                    broadcastText: true,
                },
            });
        },
        truncateText(value) {
            return truncate(value, 17);
        },
    },
};
</script>
<style>
.broadcast-notification-type {
    background-color: #00bcd4 !important;
    padding-top: 5px !important;
    width: 150px;
    height: fit-content;
    margin-top: 10px;
}
.menahal-calls-grid.container {
    padding-left: 10px !important;
    padding-right: 10px !important;
    padding-bottom: 0px !important;
}
.menahal-calls-grid .flex {
    padding: 0px !important;
}
.menahal-calls-grid .per-page {
    margin-top: 16px !important;
    margin-right: 34px;
}
.menahal-calls-grid .v-card {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2), 0 0 0 0 rgba(0, 0, 0, 0.14),
        0 0 0 0 rgba(0, 0, 0, 0.12) !important;
}
</style>
